export const langDe = {
  html_title: 'AlcmeonChat',
  title: 'Ihre Fernberater',
  subtitle: 'Wir beantworten alle Ihre Fragen - ',
  privacy_link_prefix: 'Sie können unsere Datenschutzrichtlinie lesen',
  privacy_link_label: 'hier',
  send_a_message: 'Eine Nachricht schicken...',
  send_your_email: 'Geben Sie Ihre E-Mail Adresse ein...',
  send_your_phone: 'Senden Sie Ihre Telefonnummer im Format +33612345678',
  select_an_option: 'Wählen Sie eine Option',
  close_menu: 'schließen',
  'aria_label/close': 'schließen',
  'aria_label/close-menu': 'schließen',
  'aria_label/file-upload': 'Bild oder PDF-Dokument hochladen',
  'aria_label/open_alcmeon_inmessage': 'den Chat öffnen',
  'aria_label/options': 'Optionen',
  'aria_label/send_message': 'die Nachricht senden',
  'alt/an_image': 'ein Bild',
  helperMessage1: `Hallo 🙂<br/>Haben Sie eine Frage?`,
  helperMessage2: `Wir sind hier, um zu helfen.`,
  helperMessage3: `<strong>Sie haben ein laufendes Gespräch</strong>`,
  helperMessage4: `Hier geht's weiter 👉`,
  waitingMessage: `Ein Berater wird Ihnen bald antworten. Sie befinden sich derzeit auf Position {{position}}. Ihre geschätzte Wartezeit beträgt {{time}}, bitte warten Sie.`,
  lessThan:'weniger als',
  moreThan:'mehr als',
  minutes:'min'
};
